export default "__VITE_ASSET__BkVvqYwo__"